/* eslint-disable react/prop-types */
import cx from 'classnames';
import * as dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { ICON_MAP } from '@constants/img';
import classes from './TabPanel.module.css';
import { TransactionStatus } from './TransactionStatus';

dayjs.extend(utc);
dayjs.extend(timezone);

const formatDate = (val, timeZone = 'America/New_York') => `${dayjs(Number(val)).utc(true).tz(timeZone).format('MMM DD, YYYY hh:mm a')}`;

const TransactionCell = ({ children }) => (
  <div className={classes.transaction_cell}>{children}</div>
);

const TransactionTypeCell = ({ type, flow }) => (
  <div className={classes.transaction_type}>
    <div className={cx({ [classes.transaction_type_dot]: true, [classes.transaction_type_dot_blue]: flow === 'charge' })} />
    {type}
  </div>
);

const ColumnConfig = {
  TransactionId: (minWidth) => ({
    id: 'transactionId',
    label: 'Transaction ID',
    minWidth,
    format: (val) => (<TransactionCell>{val}</TransactionCell>),
  }),
  PolicyId: (minWidth) => ({ id: 'policyId', label: 'Cover ID', minWidth }),
  Type: (minWidth) => ({
    id: 'type',
    label: 'Type',
    minWidth,
    format: (val) => {
      const { flow, type } = val || {};
      return (<TransactionTypeCell type={type} flow={flow} />);
    },
  }),
  Date: (minWidth) => ({
    id: 'date',
    label: 'Date',
    minWidth,
    format: (val, _, timeZone) => (<TransactionCell>{formatDate(val, timeZone)}</TransactionCell>),
  }),
  Amount: (minWidth) => ({
    id: 'amount',
    label: 'Amount',
    minWidth,
    align: 'right',
  }),
  OrderNumber: (minWidth) => ({
    id: 'orderName',
    label: 'Order Number',
    minWidth,
    format: (val, name) => (
      <TransactionCell>
        <section className={classes.cell_item}>
          {ICON_MAP[name] && <img className={classes.order_id_icon} src={ICON_MAP[name]} alt="" />}
          {val}
        </section>
      </TransactionCell>
    ),
  }),
  Status: (minWidth) => ({
    id: 'status',
    label: 'Status',
    minWidth,
    format: (val) => (
      <section className={classes.cell_item}>
        <TransactionStatus status={val} />
      </section>
    ),
  }),
};

export const columns = [
  ColumnConfig.TransactionId(100),
  ColumnConfig.PolicyId(130),
  ColumnConfig.OrderNumber(140),
  ColumnConfig.Type(240),
  ColumnConfig.Date(200),
  ColumnConfig.Status(40),
  ColumnConfig.Amount(40),
];
